import { CompanyTypeApi } from '@myre/app-entity-generated/sdk/angular/CompanyTypeApi';
import { type CompanyType } from '@myre/app-entity-generated/types/CompanyType';

import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyTypeService {
  private readonly _companyTypeApi = inject(CompanyTypeApi);

  public getCompanyTypes(): Observable<readonly CompanyType[]> {
    return this._companyTypeApi.getCompanyTypes();
  }
}
